import _regeneratorRuntime from "@babel/runtime/helpers/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import { IS_DEVELOPMENT_MODE_TEST } from "../constants";
import fetchFlag from "../services/fetchFlag";
import { fetchV5FeatureFlagsBatch } from "../services/v5/fetchV5FeatureFlagsBatch";
/**
 * @description Fetch all flags from the server.
 * V5 flags are batched into a single GraphQL request.
 * V2 flags are fetched individually (legacy).
 */
export default function fetchArrayFlags(_x, _x2) {
  return _fetchArrayFlags.apply(this, arguments);
}
function _fetchArrayFlags() {
  _fetchArrayFlags = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(flags, organizationId) {
    var _promises, v5Flags, v2Flags, promises, v2Promises, results;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!IS_DEVELOPMENT_MODE_TEST) {
            _context.next = 3;
            break;
          }
          _promises = flags.map(function (flag) {
            return fetchFlag(flag.flagName, flag.apiVersion, {
              organizationId: organizationId
            });
          });
          return _context.abrupt("return", Promise.all(_promises));
        case 3:
          v5Flags = flags.filter(function (f) {
            return f.apiVersion === 'V5';
          });
          v2Flags = flags.filter(function (f) {
            return f.apiVersion === 'V2';
          });
          promises = []; // V5: single batched request
          if (v5Flags.length > 0) {
            promises.push(fetchV5FeatureFlagsBatch({
              flagKeys: v5Flags.map(function (f) {
                return f.flagName;
              }),
              organizationId: organizationId
            }));
          }

          // V2: individual requests (legacy, no batch endpoint)
          if (v2Flags.length > 0) {
            v2Promises = v2Flags.map(function (flag) {
              return fetchFlag(flag.flagName, flag.apiVersion, {
                organizationId: organizationId
              });
            });
            promises.push(Promise.all(v2Promises));
          }
          _context.next = 10;
          return Promise.all(promises);
        case 10:
          results = _context.sent;
          return _context.abrupt("return", results.flat());
        case 12:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _fetchArrayFlags.apply(this, arguments);
}